import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { StoreService } from 'src/app/services/store.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-stores-attributes-values-list-setall',
  templateUrl: './stores-attributes-values-list-setall.component.html',
  styleUrls: ['./stores-attributes-values-list-setall.component.scss']
})
export class StoresAttributesValuesListSetallComponent implements OnInit {
  dataInc : any;
  types = [{ type_id : 1, name : "SI/NO"}, { type_id : 2, name : "FECHA"}, { type_id : 3, name : "OPCIONES"}, { type_id : 6, name : "NÚMERO"}, { type_id : 4, name : "RANGO"}, { type_id : 5, name : "TEXTO"}];
  startDate : Date = new Date();
  sucursal_id : number =0;
  nombre : string = ""
  curr_val! : any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    public main : MainService,
    public storeService : StoreService,
    public dialogRef: MatDialogRef<StoresAttributesValuesListSetallComponent>
  ) { 
    this.dataInc = this.data.atributo;
    this.sucursal_id = this.data.sucursal_id;
    this.nombre = this.data.nombre;
    this.curr_val = this.data.curr_val;
  }

  ngOnInit(): void {
    console.log(this.dataInc);
  }

  converToObject(obj: string){
    try{
      return JSON.parse(obj);
    }catch(ex){
      return [];
    }
  }

  getTypes(){
    return environment.att_types;
  }


  save(value:any){
    if(this.validateMinMax(value)){
    Swal.fire({
      title: '¿Esta seguro del dato ingresado?',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {      
      if (result.isConfirmed) {
        Swal.fire({
          icon: 'info',
          title: 'Guardando...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        if(this.data.setAll){
          this.storeService.setMasiveValue({ atributo_id : this.dataInc.id, value : value, tipo: this.dataInc.type_id }).subscribe(
            (result:any) => {
              if(result.message == "Success") {
                Swal.fire({
                  icon: 'success',
                  title: 'Guardado',
                  text: 'Datos guardados correctamente'          
                }).then(() => {            
                  this.dialogRef.close();
                });
              }
            },
            (err:any) => {
  
                console.log(err);
                Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
                });
              }
            
          );
        }else{
          let tempDATE = new Date();
          let newStDate = ""
          newStDate = tempDATE.toISOString().slice(0, 10);
          console.log(newStDate);
          this.storeService.newValue({ atributo_id : this.dataInc.id, sucursal_id : this.sucursal_id, new_value : value , new_value_date : newStDate, tipo: this.dataInc.type_id, curr_val: this.curr_val}).subscribe(
            (result:any) => {
              if(result.message == "Success") {
                if(result?.data?.length > 0) {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Registro no guardado',
                    html: 'Incumple con la regla <strong>' + result.data[0].nombre + '</strong> del atributo <strong>' + result.data[0].atributo + '</strong>'
                  }).then(() => {            
                  
                  });
                }
                else {
                  Swal.fire({
                    icon: 'success',
                    title: 'Guardado',
                    text: 'Datos guardados correctamente'          
                  }).then(() => {            
                  
                  });
                }
              }
            },
            (err:any) => {
  
                console.log(err);
                Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
                });
              }
            
          );
        }

      }
    });
  }
  }

  getRanges(rangeSelect : string){
    return rangeSelect.split("-");
  }

  validateMinMax(value: string | number | null | undefined){
    if (value === "" || value === null || value === undefined) {
      return true;
    }

    if (this.dataInc?.type_id === 4) {
      const rangeRaw = this.dataInc.select_data || '';
      const minmax = this.getRanges(rangeRaw);
      if (minmax.length < 2) {
        return true;
      }

      // Normalize decimals (allow comma or dot) and parse
      const parseNumber = (v: any) => {
        if (v === null || v === undefined) return NaN;
        return parseFloat(String(v).replace(/\s+/g, '').replace(',', '.'));
      };

      const num = parseNumber(value);
      const min = parseNumber(minmax[0]);
      const max = parseNumber(minmax[1]);

      if ((!isFinite(num) || !isFinite(min) || !isFinite(max)) || (num < min || num > max)) {
        Swal.fire({
          icon: 'warning',
          title: 'El valor se sale del rango establecido',
          text: 'Ingrese un valor de ' + minmax[0] + ' a ' + minmax[1]
        });
        return false;
      }

      return true;
    } else {
      return true;
    }
  }
}
